export const MIN_GUESTS_COUNT = 1;
export const MAX_GUESTS_COUNT = 100;
